import React from 'react';
import Background from '../components/Background';
import Hero from '../components/Hero';
import Features from '../components/Features';
import OngoingProjects from '../components/OngoingProjects';
import CTA from '../components/CTA';

const HomePage = () => {
  return (
    <>
      <Background />
      <div className="page">
        <Hero />
        <Features />
        <OngoingProjects />
        <CTA />
      </div>
    </>
  );
};

export default HomePage;
